import * as React from "react";
import {connect} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import Site from "../../../model/site/Site";
import {getSite} from "../../../store/view/site";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import IndividualContact from "../../../model/contact/IndividualContact";

interface ComponentProps {
	/**
	 * Contact.
	 */
	contact: Option<IndividualContact>
}

interface ReduxProps {
	/**
	 * Customer site.
	 */
	site: Option<Site>
}

type Props = ComponentProps & ReduxProps

class CustomerSiteAddress extends React.PureComponent<Props> {

	render() {
		return (
			<InfoModule icon={Icon.Site} title={"CUSTOMER ADDRESS"}>
				{
					this.props.site.map(site => {
						return (
							<span className="t-body">{site.data.address.displayName()}</span>
						)
					}).getOrElse(<span className="t-body">No address selected</span>)
				}
			</InfoModule>
		);
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		site: props.contact.flatMap(customer => customer.data.primarySiteId.flatMap(sId => getSite(sId, state)))
	}
}

export default connect(mapStateToProps)(CustomerSiteAddress)